import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, tap } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { FunctiiService } from '../functii.service';

@Component({
  selector: 'app-add-functii',
  templateUrl: './add-functii.component.html',
  styleUrls: ['./add-functii.component.scss'],
})
export class AddFunctiiComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(''),
    slug: new FormControl(''),
    observations: new FormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<AddFunctiiComponent>,
    private functiiService: FunctiiService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.functiiService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const functii = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
    };
    this.functiiService
      .addFunctii(functii)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
